export default __webpack_public_path__ + "34DcK-O-logo_mini_colored.png";